import { isJsonParsable } from '../utilities/common.utilities';
import { _get, _getAxios, serviceMain, setHeader } from './serviceMain';

type categService = {
    categoryId: number,
    description: string,
    id: number,
    name: string,
    rating: number,
    subtitle: string,
}

type serv = {
    items: categService[]
}


export async function getServiceCategories() {

    const url = '/v3/services/categories';

    const data = await fetch(serviceMain() + `${url}`, {
      method: "GET",
      headers: setHeader(url),
    });
    const jsonData = await data.json();
    return (jsonData);

  }


  export function getServices(groupCode: string, storeCode: string, card: string) {

    const queryParams = new URLSearchParams({
        groupCode: groupCode,
        storeCode: storeCode,
        card: card,
      });

    const url = '/v3/services';

    return _getAxios(url, "GET_SERVICES_TIME", "services", queryParams);

  }


